import React, { Component } from 'react'
import { Mutation, Query } from 'react-apollo'
import map from 'lodash/map'
import Loader from 'components/Loader'
import InfiniteScroll from 'react-infinite-scroller'
import { TAGS_QUERY, UPDATE_TAG_MUTATION } from 'graphql/queries'

import { Container, Table, Header, Button } from 'semantic-ui-react'
import Input from 'components/Input'

class TagsList extends Component {
  state = {
    offset: 0,
    limit: 20,
    q: '',
    hasMore: true,
  }

  handleSearchChange = event => {
    this.setState({ q: event.target.value })
  }

  renderTable() {
    const { limit, offset, q, hasMore } = this.state
    const variables = { limit, offset, q }
    return (
      <Query query={TAGS_QUERY} variables={variables}>
        {({ data, loading, fetchMore }) => {
          if (loading) {
            return <Loader />
          }

          return (
            <InfiniteScroll
              loadMore={() =>
                fetchMore({
                  variables: { offset: data.tags.length },
                  updateQuery: (prev, { fetchMoreResult, variables }) => {
                    if (!fetchMoreResult) return prev
                    if (!fetchMoreResult.tags.length) {
                      this.setState({ hasMore: false })
                    }
                    return {
                      ...prev,
                      tags: [...prev.tags, ...fetchMoreResult.tags],
                    }
                  },
                })
              }
              hasMore={hasMore}
              loader={<Loader />}
            >
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell width={6}>Name</Table.HeaderCell>
                    <Table.HeaderCell width={6}>Visible</Table.HeaderCell>
                    <Table.HeaderCell width={4}>Actions</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>{map(data.tags, this.renderRow)}</Table.Body>
              </Table>
            </InfiniteScroll>
          )
        }}
      </Query>
    )
  }

  renderRow = ({ id, name, visible }) => {
    const { limit, offset, q } = this.state
    const variables = { limit, offset, q }
    return (
      <Table.Row key={id}>
        <Table.Cell>{name}</Table.Cell>
        <Table.Cell>{JSON.stringify(visible)}</Table.Cell>
        <Table.Cell>
          <Mutation
            mutation={UPDATE_TAG_MUTATION}
            variables={{
              id,
              input: {
                visible: !visible,
              },
            }}
            update={cache => {
              const { tags } = cache.readQuery({
                query: TAGS_QUERY,
                variables,
              })

              const updatedTags = tags.map(tag => {
                if (tag.id === id) {
                  return {
                    ...tag,
                    visible: !visible,
                  }
                }
                return tag
              })

              cache.writeQuery({
                query: TAGS_QUERY,
                variables,
                data: {
                  tags: updatedTags,
                },
              })
            }}
          >
            {(updateTag, { loading }) => {
              if (loading) {
                return (
                  <Button color="orange" disabled loading>
                    Updating...
                  </Button>
                )
              }

              return (
                <Button
                  color="orange"
                  onClick={async () => {
                    await updateTag({
                      variables: { id, input: { visible: !visible } },
                    })
                  }}
                >
                  {visible ? 'Unpublish' : 'Publish'}
                </Button>
              )
            }}
          </Mutation>
        </Table.Cell>
      </Table.Row>
    )
  }

  render() {
    return (
      <Container>
        <Header as="h1" content="Tags" />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Input
            icon="search"
            placeholder="Search tags..."
            minLength={2}
            debounceTimeout={300}
            value={this.state.q}
            onChange={this.handleSearchChange}
          />
          <Button primary onClick={() => this.props.history.push('/tags/new')}>
            New Tag
          </Button>
        </div>

        {this.renderTable()}
      </Container>
    )
  }
}

export default TagsList
